var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice-remind" },
    [
      _c(
        "el-carousel",
        { attrs: { interval: 4000, height: "400px" } },
        _vm._l(_vm.dataList, function(item, index) {
          return _c("el-carousel-item", { key: index }, [
            _c("div", { staticClass: "notice-examine-box" }, [
              _c("div", { staticClass: "dialog-box__title center" }, [
                _vm._v(_vm._s(item.title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-box__time center" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("dayFormat")(item.updateTime, "YYYY-MM-DD HH:mm:ss")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "dialog-box__content",
                domProps: { innerHTML: _vm._s(item.content) }
              })
            ])
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83ce28e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83ce28e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noticeRemind.vue
// module id = null
// module chunks = 